import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const CATEGORY_META = {
  iphone: { name: "iPhone", icon: "Smartphone" },
  ipad: { name: "iPad", icon: "Tablet" },
  macbook: { name: "MacBook", icon: "LaptopMinimal" },
  windows11: { name: "Windows 11", icon: "Laptop" },
};

export function fileUrl(path) {
  return `${API}/files/${path}`;
}

export function productImage(product) {
  if (product.preview_url) return product.preview_url;
  if (product.sample_images && product.sample_images.length > 0) {
    return fileUrl(product.sample_images[0]);
  }
  return null;
}
